import { REVIEW_TYPES } from './Constants';

export const REVIEW_TYPES_RR_DEV = {
  INITIAL: 'ffa5fd89-6629-4656-b749-9fd135a04d19',
  CONTINUED_STAY: '27df5134-3a83-409e-826b-5ba9d3874144',
  INITIAL_PA: '97116aba-5919-4c31-846e-8b2943f494b8',
  APPEAL_RETROSPECTIVE: '2f03c925-e974-4838-a0bf-5b4a9b85a0f0',
  APPEAL_RETROSPECTIVE_PA: '30f720ce-d940-4431-b0e2-aaf812cb04aa',
  XSOLIS_INTERNAL: 'a38498b1-7dca-4f25-bd68-347a9cb7bc4e',
  PA_TASK_RESOLUTION: 'bab00803-d154-4fc6-adce-e22b6167336f',
  PEER_TO_PEER_TASK_RESOLUTION: '655ea8c5-dc32-4fb4-b9ee-c49d69a7a65a',
  EMERGENCY_DEPARTMENT: '03dcb5f0-e940-437b-9f47-f7e645b3beaa',
  CONTINUED_STAY_PA_REVIEW: '5b37162e-0104-423b-b447-326b948fba07',
  ESCALATE_FOR_PEER_TO_PEER: '2d23d33a-2491-46bc-bfba-9112f7f9d214',
  ESCALATE_FOR_XSOLIS_PEER_TO_PEER: '2d23d33a-2491-46bc-bfba-9112f7f9d214',
  PEER_TO_PEER: '7e55d350-ba68-45f2-89d9-32f7322cf413',
  PEER_TO_PEER_XSOLIS_PA: '45449542-2a8b-463c-a499-ba148cc3eafe',
  FINAL_STATUS: '40d3d80b-8418-420b-a510-0e07bf5e38c0',
  PAYER_REVIEW: '7870e46a-1613-410e-9528-da85704e6b66',
  MANUAL: '99',
};

export const REPORTING_REVIEW_TYPES_RR_DEV = {
  '97116aba-5919-4c31-846e-8b2943f494b8': 'Initial PA Review',
  '5b37162e-0104-423b-b447-326b948fba07': 'Continued Stay PA Review',
  '30f720ce-d940-4431-b0e2-aaf812cb04aa': 'Appeal/Retrospective',
  '7e55d350-ba68-45f2-89d9-32f7322cf413': 'Peer-to-Peer',
  '45449542-2a8b-463c-a499-ba148cc3eafe': 'Peer-to-Peer XSOLIS PA',
};

export const REVIEW_TYPES_RR_QA = {
  INITIAL: '3f5c1555-a12c-475f-9b68-4999b7093e3d',
  CONTINUED_STAY: 'f357a4fd-bbda-4a67-a2f0-a3a1489b88d1',
  INITIAL_PA: '812b82e6-b7a9-4d63-8ba9-745a6ef4835b',
  APPEAL_RETROSPECTIVE: '3cbc5963-ea90-489c-98ac-98c60c7ea00d',
  APPEAL_RETROSPECTIVE_PA: '35b4a4d7-562f-47fb-adca-f2562ea7512a',
  XSOLIS_INTERNAL: 'd52cf45b-5cb5-4925-955c-7f7b77e960c7',
  PA_TASK_RESOLUTION: 'ef37fc78-679e-4855-98f8-53adb91d3e60',
  PEER_TO_PEER_TASK_RESOLUTION: 'dcc02c30-aac9-484a-8ced-4129e7b3f072',
  EMERGENCY_DEPARTMENT: '6bd59786-c96c-4794-a283-ac83feb6e1da',
  CONTINUED_STAY_PA_REVIEW: '3b6224ad-b444-4242-ac78-9b7716c6a860',
  ESCALATE_FOR_PEER_TO_PEER: 'd2459637-ecae-4522-a164-113beadb84bf',
  ESCALATE_FOR_XSOLIS_PEER_TO_PEER: 'd2459637-ecae-4522-a164-113beadb84bf',
  PEER_TO_PEER: 'fc0e5330-d425-45ba-857f-3ac09695e3ee',
  PEER_TO_PEER_XSOLIS_PA: '302cf8c7-d987-45d1-9f08-79f3b4e076a2',
  FINAL_STATUS: 'aae8aab5-89d4-49a0-9722-bba5242916bb',
  PAYER_REVIEW: '4c0984e8-5a23-4539-980f-749c5170fbcc',
  MANUAL: '99',
};

export const REPORTING_REVIEW_TYPES_RR_QA = {
  '812b82e6-b7a9-4d63-8ba9-745a6ef4835b': 'Initial PA Review',
  '3b6224ad-b444-4242-ac78-9b7716c6a860': 'Continued Stay PA Review',
  '35b4a4d7-562f-47fb-adca-f2562ea7512a': 'Appeal/Retrospective',
  'fc0e5330-d425-45ba-857f-3ac09695e3ee': 'Peer-to-Peer',
  '302cf8c7-d987-45d1-9f08-79f3b4e076a2': 'Peer-to-Peer XSOLIS PA',
};

export const REVIEW_TYPES_RR_STAGE = {
  INITIAL: '36b23e3d-8925-4ae1-a68b-74492e49304c',
  CONTINUED_STAY: 'cad8d1d3-fd56-4bb9-86b6-89bfd7a38f91',
  INITIAL_PA: '67d41921-8483-41e4-9728-8b0c0e740e52',
  APPEAL_RETROSPECTIVE: '36752d6c-d110-4af2-a87a-4a7239733a7a',
  APPEAL_RETROSPECTIVE_PA: '960255a3-b436-45ea-bc46-abbaad84f75a',
  XSOLIS_INTERNAL: '737ef74f-439d-44bc-8f83-effbdf8b79ca',
  PA_TASK_RESOLUTION: 'fb57c9a4-2c08-4aad-95bb-6fbd1fdaf490',
  PEER_TO_PEER_TASK_RESOLUTION: 'fe888831-f5e9-4648-94ac-d4738a6b1778',
  EMERGENCY_DEPARTMENT: 'a2ffce4a-1054-4b5d-b101-b558becd1f77',
  CONTINUED_STAY_PA_REVIEW: '0bbd8269-ca0b-480a-9b71-c2303b868c14',
  ESCALATE_FOR_PEER_TO_PEER: '71a002a6-3251-4e21-ac1d-ad98a7d78ddd',
  ESCALATE_FOR_XSOLIS_PEER_TO_PEER: '71a002a6-3251-4e21-ac1d-ad98a7d78ddd',
  PEER_TO_PEER: '1460ca52-fcf6-4739-b263-5f097665a660',
  PEER_TO_PEER_XSOLIS_PA: 'af97166a-60a1-4118-9b46-fbce42edb60e',
  FINAL_STATUS: '2bf9507f-31d5-4e12-9928-5deb0ff55287',
  PAYER_REVIEW: '532b1f37-4a1a-4b0a-b1ac-41acd1ab128a',
  MANUAL: '99',
};

export const REPORTING_REVIEW_TYPES_RR_STAGE = {
  '67d41921-8483-41e4-9728-8b0c0e740e52': 'Initial PA Review',
  '0bbd8269-ca0b-480a-9b71-c2303b868c14': 'Continued Stay PA Review',
  '960255a3-b436-45ea-bc46-abbaad84f75a': 'Appeal/Retrospective',
  '1460ca52-fcf6-4739-b263-5f097665a660': 'Peer-to-Peer',
  'af97166a-60a1-4118-9b46-fbce42edb60e': 'Peer-to-Peer XSOLIS PA',
};

export const REVIEW_TYPES_RR_DEMO = {
  INITIAL: '42190a28-a0a8-41b3-9a06-7fa91b8e32a0',
  CONTINUED_STAY: '0f7896d5-69ea-4f6d-9458-b32708421f97',
  INITIAL_PA: '05b01522-c66a-44b9-8b26-fe999587b6a5',
  APPEAL_RETROSPECTIVE: 'ba667ccf-09a3-46f3-ab2f-a9fd94de4fb4',
  APPEAL_RETROSPECTIVE_PA: '8a67cd26-9f22-4d56-9ac6-8f77c93d14e8',
  XSOLIS_INTERNAL: '9dc0afaf-6c84-46f8-a698-ec2829cb5510',
  PA_TASK_RESOLUTION: '627615ad-5b71-4844-aebf-f69296752aeb',
  PEER_TO_PEER_TASK_RESOLUTION: 'd5449a5f-9a4f-40d2-8eb7-79deccbbcd69',
  EMERGENCY_DEPARTMENT: 'd1eb837f-2fe8-4ec6-9a10-23a32cfb212d',
  CONTINUED_STAY_PA_REVIEW: 'dc577275-e1ef-42ea-b137-e16a319212a1',
  ESCALATE_FOR_PEER_TO_PEER: 'ca4da854-a1bf-4078-a55d-1f4dde716e23',
  PEER_TO_PEER: 'bda5a9b9-78be-4a2d-b37f-74a19f3dcc89',
  PEER_TO_PEER_XSOLIS_PA: '1b711b7b-c0e8-4440-b550-1d858b0040bb',
  FINAL_STATUS: 'bd80ebe9-dde3-4b5e-9fb5-d3f56b634538',
  PAYER_REVIEW: '5c35e398-44cb-4de8-8030-9a5bf36bab6c',
  MANUAL: '99',
};

export const REVIEW_TYPES_RR_DEMO2 = {
  INITIAL: 'd0da0ef5-fce9-446d-9c4c-14f05d049794',
  CONTINUED_STAY: '2ef64bcd-a016-44e9-80ac-6250fff9195b',
  INITIAL_PA: 'a4ffc69f-e42c-4f70-acd7-6038eab05694',
  APPEAL_RETROSPECTIVE: '9673637c-23fc-4f8a-8f72-fca01728a489',
  APPEAL_RETROSPECTIVE_PA: 'db4f10f8-6bbc-4894-a30e-8a2e22c63dae',
  XSOLIS_INTERNAL: 'a5ddce0f-14b4-4bc8-bd7d-d3f462a71951',
  PA_TASK_RESOLUTION: '97b3fa9d-644c-4a02-90e2-9b9766d920ce',
  PEER_TO_PEER_TASK_RESOLUTION: '0ae6e9ca-ff84-444b-8535-a650e81ffb98',
  EMERGENCY_DEPARTMENT: '718e1df8-7599-4d6f-b966-d03d255ee5ad',
  CONTINUED_STAY_PA_REVIEW: 'f93fc858-61c0-405a-b6ae-b7d2b2126a10',
  ESCALATE_FOR_PEER_TO_PEER: '68f3643f-5e1e-4b79-bd29-85cc1a28ea9a',
  PEER_TO_PEER: '6054d27c-b127-4d41-8573-0fd05cd84683',
  PEER_TO_PEER_XSOLIS_PA: 'e8f30d04-99df-4f0a-8b11-0b6b620b7357',
  FINAL_STATUS: 'b3108fdf-c2a5-42f7-8b67-ac117607606a',
  PAYER_REVIEW: '2e2f5908-23d7-4c35-a2aa-1e250c303836',
  MANUAL: '99',
};

export const REPORTING_REVIEW_TYPES_RR_DEMO = {
  '05b01522-c66a-44b9-8b26-fe999587b6a5': 'Initial PA Review',
  'dc577275-e1ef-42ea-b137-e16a319212a1': 'Continued Stay PA Review',
  'ba667ccf-09a3-46f3-ab2f-a9fd94de4fb4': 'Appeal/Retrospective',
  'bda5a9b9-78be-4a2d-b37f-74a19f3dcc89': 'Peer-to-Peer',
  '1b711b7b-c0e8-4440-b550-1d858b0040bb': 'Peer-to-Peer XSOLIS PA',
};

export const REVIEW_TYPES_RR_PROD = {
  INITIAL: '3a7ca2b7-866b-44e9-bef5-68772a02b3dd',
  CONTINUED_STAY: '332ba1cd-46f2-4550-b898-f67ea7801291',
  INITIAL_PA: 'fa0a4178-e0f9-49c8-b892-d9a34babbc92',
  APPEAL_RETROSPECTIVE: '8f7b27d1-2f3e-4140-8beb-5692e259b935',
  APPEAL_RETROSPECTIVE_PA: '3c25debd-f4b8-4f92-b7d4-5516c14cfee5',
  XSOLIS_INTERNAL: '69bf07f5-7280-430f-b34d-10af34916ce0',
  PA_TASK_RESOLUTION: 'ad4ae98b-5932-407a-847c-3e45e9a4d73d',
  PEER_TO_PEER_TASK_RESOLUTION: 'b6182888-957f-4d7f-841e-a8546afded34',
  EMERGENCY_DEPARTMENT: '1a3957d9-162e-4dbf-92ba-46bc7f4e849b',
  CONTINUED_STAY_PA_REVIEW: '38355086-b9d1-4778-9c64-7324fff183bb',
  ESCALATE_FOR_PEER_TO_PEER: 'dac33b03-7e42-41e4-9495-d2df5042df31',
  ESCALATE_FOR_XSOLIS_PEER_TO_PEER: 'dac33b03-7e42-41e4-9495-d2df5042df31',
  PEER_TO_PEER: '105e1944-3dc3-4d02-8194-a89a97f14189',
  PEER_TO_PEER_XSOLIS_PA: '229e189e-6393-42df-93ef-a42712738901',
  FINAL_STATUS: '927df828-681f-4955-9501-f3e6e412daeb',
  PAYER_REVIEW: '3438e1ba-ac3b-4777-a309-5cbfa46eee04',
  MANUAL: '99',
};

export const REPORTING_REVIEW_TYPES_RR_PROD = {
  'fa0a4178-e0f9-49c8-b892-d9a34babbc92': 'Initial PA Review',
  '38355086-b9d1-4778-9c64-7324fff183bb': 'Continued Stay PA Review',
  '3c25debd-f4b8-4f92-b7d4-5516c14cfee5': 'Appeal/Retrospective',
  '105e1944-3dc3-4d02-8194-a89a97f14189': 'Peer-to-Peer',
  '229e189e-6393-42df-93ef-a42712738901': 'Peer-to-Peer XSOLIS PA',
};

export const REVIEW_TYPE_ID_UR_POP = [
  REVIEW_TYPES_RR_DEV.INITIAL,
  REVIEW_TYPES_RR_DEV.CONTINUED_STAY,
  REVIEW_TYPES_RR_DEV.APPEAL_RETROSPECTIVE,
  REVIEW_TYPES_RR_DEV.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_TYPES_RR_QA.INITIAL,
  REVIEW_TYPES_RR_QA.CONTINUED_STAY,
  REVIEW_TYPES_RR_QA.APPEAL_RETROSPECTIVE,
  REVIEW_TYPES_RR_QA.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_TYPES_RR_STAGE.INITIAL,
  REVIEW_TYPES_RR_STAGE.CONTINUED_STAY,
  REVIEW_TYPES_RR_STAGE.APPEAL_RETROSPECTIVE,
  REVIEW_TYPES_RR_STAGE.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_TYPES_RR_PROD.INITIAL,
  REVIEW_TYPES_RR_PROD.CONTINUED_STAY,
  REVIEW_TYPES_RR_PROD.APPEAL_RETROSPECTIVE,
  REVIEW_TYPES_RR_PROD.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_TYPES_RR_DEMO.INITIAL,
  REVIEW_TYPES_RR_DEMO.CONTINUED_STAY,
  REVIEW_TYPES_RR_DEMO.APPEAL_RETROSPECTIVE,
  REVIEW_TYPES_RR_DEMO.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_TYPES_RR_DEMO2.INITIAL,
  REVIEW_TYPES_RR_DEMO2.CONTINUED_STAY,
  REVIEW_TYPES_RR_DEMO2.APPEAL_RETROSPECTIVE,
  REVIEW_TYPES_RR_DEMO2.ESCALATE_FOR_PEER_TO_PEER,
  REVIEW_TYPES.INITIAL,
  REVIEW_TYPES.CONTINUED_STAY,
  REVIEW_TYPES.APPEAL_RETROSPECTIVE,
  REVIEW_TYPES.ESCALATE_FOR_PEER_TO_PEER,
];

export const REVIEW_TYPE_ID_PA_POP = [
  REVIEW_TYPES_RR_DEV.INITIAL_PA,
  REVIEW_TYPES_RR_DEV.CONTINUED_STAY_PA_REVIEW,
  REVIEW_TYPES_RR_DEV.APPEAL_RETROSPECTIVE_PA,
  REVIEW_TYPES_RR_DEV.PEER_TO_PEER,
  REVIEW_TYPES_RR_QA.INITIAL_PA,
  REVIEW_TYPES_RR_QA.CONTINUED_STAY_PA_REVIEW,
  REVIEW_TYPES_RR_QA.APPEAL_RETROSPECTIVE_PA,
  REVIEW_TYPES_RR_QA.PEER_TO_PEER,
  REVIEW_TYPES_RR_STAGE.INITIAL_PA,
  REVIEW_TYPES_RR_STAGE.CONTINUED_STAY_PA_REVIEW,
  REVIEW_TYPES_RR_STAGE.APPEAL_RETROSPECTIVE_PA,
  REVIEW_TYPES_RR_STAGE.PEER_TO_PEER,
  REVIEW_TYPES_RR_PROD.INITIAL_PA,
  REVIEW_TYPES_RR_PROD.CONTINUED_STAY_PA_REVIEW,
  REVIEW_TYPES_RR_PROD.APPEAL_RETROSPECTIVE_PA,
  REVIEW_TYPES_RR_PROD.PEER_TO_PEER,
  REVIEW_TYPES_RR_DEMO.INITIAL_PA,
  REVIEW_TYPES_RR_DEMO.CONTINUED_STAY_PA_REVIEW,
  REVIEW_TYPES_RR_DEMO.APPEAL_RETROSPECTIVE_PA,
  REVIEW_TYPES_RR_DEMO.PEER_TO_PEER,
  REVIEW_TYPES_RR_DEMO2.INITIAL_PA,
  REVIEW_TYPES_RR_DEMO2.CONTINUED_STAY_PA_REVIEW,
  REVIEW_TYPES_RR_DEMO2.APPEAL_RETROSPECTIVE_PA,
  REVIEW_TYPES_RR_DEMO2.PEER_TO_PEER,
  REVIEW_TYPES.INITIAL_PA_REVIEW,
  REVIEW_TYPES.CONTINUED_STAY_PA_REVIEW,
  REVIEW_TYPES.PEER_TO_PEER,
];

export const REVIEW_TYPE_ID_PAYER_POP = [
  REVIEW_TYPES_RR_DEV.PAYER_REVIEW,
  REVIEW_TYPES_RR_QA.PAYER_REVIEW,
  REVIEW_TYPES_RR_STAGE.PAYER_REVIEW,
  REVIEW_TYPES_RR_PROD.PAYER_REVIEW,
  REVIEW_TYPES_RR_DEMO.PAYER_REVIEW,
  REVIEW_TYPES_RR_DEMO2.PAYER_REVIEW,
  REVIEW_TYPES.PAYER_REVIEW,
];
